import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useCallback, useState } from 'react'
import { Header } from '@/components/generals/header'
import { MobileNav, Sidebar } from '@/components/generals/sidebar'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    const [menuOpen, setMenuOpen] = useState(false)
    const closeMenu = useCallback(() => setMenuOpen(false), [])

    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[80] focus:rounded-md focus:bg-navy focus:px-4 focus:py-2 focus:text-sm focus:text-white'
            >
                پرش به محتوای اصلی
            </a>

            <Header onOpenMenu={() => setMenuOpen(true)} />

            <div className='flex flex-1'>
                <Sidebar />

                <div className='flex min-w-0 flex-1 flex-col'>
                    <main id='main-content' className='flex-1'>
                        {children}
                    </main>

                    <Footer />
                </div>
            </div>

            <MobileNav open={menuOpen} onClose={closeMenu} />
        </div>
    )
}
